document.addEventListener("DOMContentLoaded", () => {

    gsap.registerPlugin(ScrollTrigger);

    const header = document.querySelector(
        "body#template-collection-between .header"
    );

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".scroll-animation",
            start: "top top",
            end: "+=2200",
            scrub: 1,
            pin: true,

            onEnter: () => {
                header.classList.remove("header-black");
            },

            onLeave: () => {
                header.classList.add("header-black");
            },

            onEnterBack: () => {
                header.classList.remove("header-black");
            },

            onLeaveBack: () => {
                header.classList.remove("header-black");
            }
        }
    });

    // ---- Phase 1 (0 -> 1): image flies in and spins into place ----
    // .product-image-wrapper already centers the image inside .compass-stage,
    // so this tween only needs to handle the entrance motion relative to that.
    
    // tl.fromTo(".product-image",
    //     { x: -720, y:500, scale: 0.4, rotation: 0 },
    //     { x: 0, y: 0, scale: 1, rotation: -360, duration: 1, ease: "none" }
    // )

    tl.fromTo(".product-image",
    {
        x: 1100,
        y: 200,
        scale: 0.4,
        rotation: 0
    },
    {
        x: 0,
        y: 0,
        scale: 1,
        rotation: -360,
        duration: 1,
        ease: "none"
    }
)

    // ---- Phase 2 (1 -> 2): image settles + keeps spinning gently ----
    .to(".product-image",
        { scale: 2, rotation: -720, duration: 1, ease: "none" }
    , 1)

    // ---- Phase 3 (starts at the 50% mark, i.e. position 1): compass reveal ----
    // rings fade/scale in first
    // .fromTo(".compass-ring",
    //     { opacity: 0, scale: 0.75 },
    //     { opacity: 1, scale: 1, duration: 0.4, stagger: 0.1, ease: "power2.out" }
    // , 1)

    .fromTo(".compass-ring",
        {
            opacity: 0,
            scale: 0.75,
            xPercent: -50,
            yPercent: -50
        },
        {
            opacity: 1,
            scale: 1,
            xPercent: -50,
            yPercent: -50,
            duration: 0.6,
            stagger: 0.12,
            ease: "power2.out"
        },
        1
    )

    // ---- Ring rotation ----

    .to(".compass-ring--outer", {
        rotation: 360,
        duration: 2,
        ease: "none"
    }, 1)

    .to(".compass-ring--middle", {
        rotation: -180,
        duration: 2,
        ease: "none"
    }, 1)

    .to(".compass-ring--inner", {
        rotation: 180,
        duration: 2,
        ease: "none"
    }, 1)

    .to(".compass-ring--core", {
        rotation: -360,
        duration: 2,
        ease: "none"
    }, 1)

    .fromTo(".compass-sparkle--N",
    {
        opacity: 0,
        y: -20
    },
    {
        opacity: 1,
        y: 0,
        duration: 0.4
    },1.7)

    // EAST - comes from right
    .fromTo(".compass-sparkle--E",
        {
            opacity: 0,
            x: 20
        },
        {
            opacity: 1,
            x: 0,
            duration: 0.4
        },
        1.8
    )

    // SOUTH - comes from bottom
    .fromTo(".compass-sparkle--S",
        {
            opacity: 0,
            y: 20
        },
        {
            opacity: 1,
            y: 0,
            duration: 0.4
        },
        1.9
    )

    // WEST - comes from left
    .fromTo(".compass-sparkle--W",
        {
            opacity: 0,
            x: -20
        },
        {
            opacity: 1,
            x: 0,
            duration: 0.4
        },
        2
    )

    // cross-lines draw outward from the center
    .fromTo(".compass-line--horizontal",
        { scaleX: 0 },
        { scaleX: 1, duration: 0.4, ease: "power2.out" }
    , 1.1)
    .fromTo(".compass-line--vertical",
        { scaleY: 0 },
        { scaleY: 1, duration: 0.4, ease: "power2.out" }
    , 1.1)

    // the four pillars fly in from their own side of the compass
    .fromTo(".pillar--top",
        { opacity: 0, y: -60 },
        { opacity: 1, y: 0, duration: 0.5, ease: "back.out(1.6)" }
    , 1.2)
    .fromTo(".pillar--right",
        { opacity: 0, x: 60 },
        { opacity: 1, x: 0, duration: 0.5, ease: "back.out(1.6)" }
    , 1.3)
    .fromTo(".pillar--bottom",
        { opacity: 0, y: 60 },
        { opacity: 1, y: 0, duration: 0.5, ease: "back.out(1.6)" }
    , 1.4)
    .fromTo(".pillar--left",
        { opacity: 0, x: -60 },
        { opacity: 1, x: 0, duration: 0.5, ease: "back.out(1.6)" }
    , 1.5)

    // sparkles twinkle in last, once everything else has landed
    .fromTo(".compass-sparkle",
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.3, stagger: 0.08, ease: "back.out(2)" }
    , 1.7)

    // ---- left-side heading/description, unchanged timing ----
    .fromTo(".product-content",
        { opacity: 1, y: 80 },
        { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" }
    , 0.5);
});
